import {
  AiAgentStep,
  SuggestedReplyToolCall,
} from "@/v2/entities/chain-of-thoughts/ChainOfThoughts.model";
import {
  ToolInvocationStepData,
  ToolResponseStepData,
} from "@/v2/features/simulator/parts/chainOfThoughts/ChainOfThoughts.types";

export function convertSuggestedReplyToolCallsToChainOfThoughtSteps(
  toolCalls: SuggestedReplyToolCall[]
): (ToolInvocationStepData | ToolResponseStepData)[] {
  return toolCalls.flatMap((toolCall) => {
    const toolId =
      toolCall.toolCallId || `tool-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    const toolArgs = toolCall.args ?? {};
    const steps: (ToolInvocationStepData | ToolResponseStepData)[] = [
      {
        stepKey: "tool-invocation",
        toolName: toolCall.toolName || "unknown",
        toolArgs,
        toolId,
      },
      {
        stepKey: "tool-response",
        toolName: toolCall.toolName || "unknown",
        toolId,
        result: toolCall.result,
        state: "result",
      },
    ];
    return steps;
  });
}

export function convertAiAgentStepsToChainOfThoughtSteps(
  steps: AiAgentStep[]
): (ToolInvocationStepData | ToolResponseStepData)[] {
  return steps.flatMap((step) => {
    const convertedSteps: (ToolInvocationStepData | ToolResponseStepData)[] =
      [];

    if (step.toolCalls && step.toolCalls.length > 0) {
      step.toolCalls.forEach((toolCall: any) => {
        let parsedArgs = {};

        if (toolCall.args) {
          if (typeof toolCall.args === "string") {
            try {
              parsedArgs = JSON.parse(toolCall.args);
            } catch (error) {
              console.error("Failed to parse tool arguments:", error);
              parsedArgs = {};
            }
          } else {
            parsedArgs = toolCall.args;
          }
        }

        convertedSteps.push({
          stepKey: "tool-invocation",
          toolName: toolCall.toolName || "unknown",
          toolArgs: parsedArgs,
          toolId: toolCall.toolCallId || toolCall.id || `tool-${Date.now()}`,
        });
      });
    }

    if (step.toolResults && step.toolResults.length > 0) {
      step.toolResults.forEach((toolResult: any) => {
        convertedSteps.push({
          stepKey: "tool-response",
          toolName: toolResult.toolName || "unknown",
          toolId:
            toolResult.toolCallId || toolResult.id || `tool-${Date.now()}`,
          result: toolResult.result,
          state: toolResult.state || "result",
        });
      });
    }

    return convertedSteps;
  });
}
